import { Button } from '@/shadcn-ui/button';
import { colors } from '@/theme/colors';
import Diamond from '@/icons/diamond';
import NewVehicleInfoDialog from './new-vehicle-info-dialog';

export default function NewVehicleInfoPanel() {
  const trigger = (
    <Button variant="clear" className="inline-block h-auto w-auto">
      <p className="link-dashed-body2 text-flexcar-neutral100 decoration-flexcar-neutral100 hover:text-flexcar-neutral100 hover:decoration-flexcar-neutral100">
        Learn more
      </p>
    </Button>
  );

  return (
    <div
      className="flex w-full gap-4 rounded-3xl p-6 text-sm font-normal text-flexcar-neutral100"
      style={{
        background: `linear-gradient(90deg, ${colors.gradientPillPrimary} 0%, ${colors.blue20} 100%)`,
      }}
    >
      <div>
        <Diamond size={{ height: 24, width: 24 }} />
      </div>
      <div className="flex flex-col items-start gap-1">
        <p className="body2 text-flexcar-neutral100">
          For a one-time $499 surcharge, enjoy a brand-new car—no ownership hassles, more
          savings.
        </p>

        <NewVehicleInfoDialog trigger={trigger} />
      </div>
    </div>
  );
}
